/**
 * Exports a function that generates an ID using either crypto (if available)
 * or Math.random.
 */
import { Base62 } from '@js-sdk/encoding';
// Check whether we have the required APIs to use the Web Crypto based ID
// generator.
const hasAPI = typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function';
/**
 * Generates an ID using Web Crypto.
 *
 * @return The generated ID.
 */
function generateIdWithCrypto() {
    const numbers = new Uint8Array(16);
    crypto.getRandomValues(numbers);
    const id = Base62.toHex(numbers.join(''), 40);
    return id.slice(0, 40);
}
/**
 * Generates an ID Math.random.
 *
 * @return The generated ID.
 */
function generateIdWithRandom() {
    const numbers = new Array(27);
    let l = numbers.length;
    while (l--) {
        numbers[l] = Math.floor(Math.random() * (9 - 1));
    }
    const id = Base62.toHex(numbers.join(''), 40);
    return id;
}
const generate = hasAPI ? generateIdWithCrypto : generateIdWithRandom;
/**
 * Used as the LocalStorage key for a generated ID.
 */
const DEFAULT_DEVICE_ID_KEY = '_spharmony_device_id';
/**
 * Utility function that is used to generate an id.
 *
 * @param maybeId - If set to a non-empty string, this value is
 *     immediately returned. Otherwise, the function will generate and store an
 *     id.
 * @param noCached - When set to true, the function will always return a
 *     new ID when it's called, bypassing any generated ids.
 * @return The generated ID.
 */
function getDeviceId(maybeId, noCached = false) {
    if (maybeId && typeof maybeId === 'string') {
        return maybeId;
    }
    if (noCached) {
        return generate();
    }
    let stored = localStorage.getItem(DEFAULT_DEVICE_ID_KEY);
    if (!stored) {
        stored = generate();
        localStorage.setItem(DEFAULT_DEVICE_ID_KEY, stored);
    }
    return stored;
}
export const DeviceId = {
    get: getDeviceId,
    generate: generate,
    // Expose for unit tests.
    generateWithCrypto: generateIdWithCrypto,
    generateWithRandom: generateIdWithRandom,
};
//# sourceMappingURL=device_id.js.map